/* eslint-disable */
import {
  Box,
  Text,
  Image,
  Icon,
  Container,
  Flex,
} from '@chakra-ui/react';
import Carousel from 'react-multi-carousel';
import Skeleton from 'react-loading-skeleton';
import { useRef, useEffect } from 'react';
import moment from 'moment';
import { AiOutlineCalendar } from 'react-icons/ai';
import { IoLocationOutline } from 'react-icons/io5';
import { PiArrowLeft, PiArrowRight } from 'react-icons/pi';
import { ReactComponent as PintarIcon } from '../../assets/svg/pintar_white.svg';
import { useEventPintarPublicContext, EventPintarItem } from '../../controller/public/event_pintar';

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1024, min: 560 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 560, min: 0 },
    items: 1,
  },
};

const EventPintar = () => {
  const { listData, loadingData } = useEventPintarPublicContext().state;
  const { getEventPintar } = useEventPintarPublicContext();

  useEffect(() => {
    getEventPintar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const carouselRef = useRef<any>(null);

  const handleNext = () => {
    carouselRef.current?.next();
  };

  const handlePrevious = () => {
    carouselRef.current?.previous();
  };

  const formatDate = (dateString: string): string => {
    const dateObject = moment(dateString, 'YYYY-MM-DD HH:mm:ss');
    return dateObject.format('DD MMM YYYY');
  };

  const renderLoadingSkeleton = () => (
    <Skeleton
      count={4}
      style={{ height: '400px', width: '280px', marginRight: '20px' }}
      inline={true}
    />
  );

  const renderNoEventData = () => (
    <Box mx="auto" textAlign="center" my={20}>
      <Text fontSize="xl" color="gray.400">
        Belum Ada Event Pintar
      </Text>
    </Box>
  );

  const renderEventCard = (item: EventPintarItem) => {
    const handleCardClick = () => {
      window.location.href = `/detail/event-pintar/${item.id}`;
    };

    return (
      <Box 
        key={item.id} 
        h="full"
        borderRadius="lg"
        overflow="hidden"
        border="1px solid"
        borderColor="gray.200"
        bg="white" 
        mr={4}
        _hover={{ shadow: 'lg', cursor: 'pointer' }}
        transition="all"
        transitionDuration="500ms"
        onClick={handleCardClick}
        p={4}
        display="flex"
        flexDirection="column"
      >
        {/* Thumbnail */}
        <Box position="relative">
          <Box position="absolute" top={1} left={2} zIndex={1}>
            <Icon as={PintarIcon} boxSize={8} />
          </Box>
          <Image
            src={item.image}
            fallback={<Skeleton width="full" height="full" style={{ aspectRatio: '2/1' }} />}
            alt="Gambar Event"
            backgroundSize="cover"
            bgRepeat="no-repeat"
            style={{ aspectRatio: '2/1' }}
            rounded="lg"
            w="full"
          />
        </Box>

        {/* Content */}
        <Box mt={3} flex="1" display="flex" flexDirection="column">
          <Text fontWeight="medium" fontSize="lg" color="black">
            {item.title}
          </Text>
          
          <Box display="flex" mt={1} alignItems="center" gap={2}>
            <Icon as={AiOutlineCalendar} mr={2} />
            <Text mr={1}>{formatDate(item?.training_start_date)}</Text>
            <Text mr={1}>s.d</Text>
            <Text>{formatDate(item?.training_end_date)}</Text>
          </Box>
          
          <Box display="flex" mt={1} alignItems="center" gap={2}>
            <Icon as={IoLocationOutline} mr={2} />
            <Text>{item.location}</Text>
          </Box>
        </Box>
      </Box>
    );
  };

  const renderContent = () => {
    if (loadingData) {
      return renderLoadingSkeleton();
    }
    
    if (!listData.length) {
      return renderNoEventData();
    }
    
    const carouselItems = listData.map((item: EventPintarItem) => renderEventCard(item));
    
    return (
      <Carousel responsive={responsive} ref={carouselRef} arrows={false}>
        {carouselItems}
      </Carousel>
    );
  };

  return (
      <Box bg="white">
       <Container maxW="8xl" py={12} w="full">
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          w="full"
        >
          <Flex direction="column">
            <Text
              as="h2"
              fontWeight="semibold"
              letterSpacing="tight"
              fontSize={{ base: 'xl', md: '2xl' }}
            >
              Event Pintar
            </Text>
            <Text>Temukan rangkaian event yang menarik dari PINTAR</Text>
          </Flex>

          <Flex direction="row" className="gap-2">
            <button
              onClick={handlePrevious}
              className="bg-white shadow-md w-10 h-10 flex items-center justify-center rounded-lg hover:shadow-lg hover:bg-gray-200"
            >
              <PiArrowLeft size={30} className="text-gray-500" />
            </button>
            <button
              onClick={handleNext}
              className="bg-white shadow-md w-10 h-10 flex items-center justify-center rounded-lg hover:shadow-lg hover:bg-gray-200"
            >
              <PiArrowRight size={30} className="text-gray-500" />
            </button>
          </Flex>
        </Box>
        <Box mt={5}>
          {renderContent()}
        </Box>
        </Container>
      </Box>
  );
};

export default EventPintar;
